import { render, staticRenderFns } from "./SparepartsForm.vue?vue&type=template&id=142a40d2&scoped=true"
import script from "./SparepartsForm.vue?vue&type=script&lang=js"
export * from "./SparepartsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a40d2",
  null
  
)

export default component.exports